import React from 'react';
import FileSave1 from  './FileSave1';

const Ograf = () => {
    return (
        <div>
            <FileSave1 />
        </div>
    )
}

export default Ograf
